import type { Interface } from 'ethers'
import { Gnosis_safe__factory } from '@/types/contracts/factories/@safe-global/safe-deployments/dist/assets/v1.3.0/Gnosis_safe__factory'

let safeInterface: Interface | null = null

/**
 * Get or create the Safe contract interface
 * Uses the Gnosis Safe v1.3.0 ABI
 */
export const getSafeInterface = (): Interface => {
  if (!safeInterface) {
    safeInterface = Gnosis_safe__factory.createInterface()
  }
  return safeInterface
}
